import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import Logo from './logo';
import devIcon from './dev-icon.png'
import arrow from './arrow.png'

const MainContent = () => {
    return (
        <div>
            <Logo />
            <div className="main-content">
                <section className="welcome-section">
                    <h2>Welcome to the DNA Developer Portal!</h2>
                    <div className="icon-text-group">
                        <img src={devIcon} className='developer-icon' alt='DevTeam'></img>
                        <span className="text-background">Designed for Developers</span>
                    </div>
                    <p className="description-heading">
                        Backstage - the power of self-service cloud analytics at your fingertips!
                    </p>
                    <p className="description">We're delighted to have you here. This portal is based on the Open Source project Backstage and is designed with developers in mind, putting the power of self-service cloud analytics at your fingertips. Whether you're a long-time user or a new member of our community, this is your go-to platform for provisioning resources and interacting with DNA automated and API services. For Support and Ops requests, including whitelisting, new spokes, etc. - please leverage the Mars ServiceNow interface.</p>
                    <p className="description">We highly value your time and flexibility, therefore this portal is designed to provide you the possibility to create the building blocks for your data and analytics solutions with cloud-native and DevOps best practices in mind!</p>
                    <p className="description">Our mission is to empower you to drive more value of our your data, 24/7, at your own pace.</p>
                </section>
            </ div>
        </div >
    )
};

const Sidebar = () => (
    <aside className="sidebar">
        <h2 className="quick-links-title">Quick Links</h2>
        <div className="component-button-container">
            <Link to="/create" className="component-button">
                <div className="component-text">
                    <h3>Create your application</h3>
                    <p>Explore the portal by creating your application</p>
                </div>
                <div className="component-arrow">
                    <img src={arrow} alt="Arrow" />
                </div>
            </Link>
        </div>
        <a href='https://team.effem.com/sites/dnateam/' className="component-button-container">
            <div className="component-button">
                <div className="component-text">
                    <h3>DNA Team Space</h3>
                    <p>Check out our documentation and recent news</p>
                </div>
                <div className="component-arrow">
                    <img src={arrow} alt="Arrow" />
                </div>
            </div>
        </a>
        <a href='https://team.effem.com/sites/dnateam/SitePages/DNA-Office-Hours.aspx' className="component-button-container">
            <div className="component-button">
                <div className="component-text">
                    <h3>DNA Platform Service Catalogue</h3>
                    <p>Explore the list of Services provided by DNA Development & Engineering team</p>
                </div>
                <div className="component-arrow">
                    <img src={arrow} alt="Arrow" />
                </div>
            </div>
        </a>
        <a href='https://team.effem.com/sites/dnateam/SitePages/Platform-Engineering-&-Development-Release-Train-launch-in-DNA.aspx?source=FromWebpart&promotedState=1' className="component-button-container">
            <div className="component-button">
                <div className="component-text">
                    <h3>DNA Ways of Working</h3>
                    <p>Understand the DNA processess and demand flow</p>
                </div>
                <div className="component-arrow">
                    <img src={arrow} alt="Arrow" />
                </div>
            </div>
        </a>
        <a href='https://team.effem.com/:w:/s/DataSolutionsArchitecture2/ESQKz50HjOlCu6_OXspCpmEBFsuuX3MKZTcIXrUiwu7vCQ?e=6vf1lM' className="component-button-container">
            <div className="component-button">
                <div className="component-text">
                    <h3>Google Cloud Platform Playbook</h3>
                    <p>Explore Google Cloud Platform Playbook</p>
                </div>
                <div className="component-arrow">
                    <img src={arrow} alt="Arrow" />
                </div>
            </div>
        </a>
        <a href='https://team.effem.com/:w:/s/DataSolutionsArchitecture2/EU_tg6BUO8pKvryA2uT3FEYBP64KHUdHoj5jsSfxrBS4IQ?e=SN0KMq' className="component-button-container">
            <div className="component-button">
                <div className="component-text">
                    <h3>DNA Playbook</h3>
                    <p>Explore the DNA Playbook</p>
                </div>
                <div className="component-arrow">
                    <img src={arrow} alt="Arrow" />
                </div>
            </div>
        </a>
        <a href='https://github.com/Mars-DNA/Global-DNA-Resource-Catalog/releases/latest' className="component-button-container">
            <div className="component-button">
                <div className="component-text">
                    <h3>Latest Resource Catalog Release</h3>
                    <p>View the latest release in the Global DNA Resource Catalog</p>
                </div>
                <div className="component-arrow">
                    <img src={arrow} alt="Arrow" />
                </div>
            </div>
        </a>

        <ContactSection />
    </aside>
);

const ContactSection = () => {
    return (
        <div className='contact-section'>
            <div className="component-button">
                <div className="component-text">
                    <h3>Facing issues or having improvement ideas?</h3>
                </div>
            </div>
            <br />
            <a href="mailto:dnasupport@effem.com" className="contact-button">Contact us</a>
        </div >
    );
};

export const HomePage = () => (
    <div className="HomePage">
        <div className="content-area">
            <div className="main-content">
                <MainContent />
            </div>
            <Sidebar />
        </div>
    </div>
);